import base from '@/api/base.api';
import axios from 'axios';
const namespace = 'file-document';

export default {
    listByGroup: (group, params) => {
        return axios.get(`${base.baseUrl}/${namespace}/group/${group}`, {params: params})
    },
}
